import str from '../common/strings';

export default {
    filters: {
        withThousandsSeparator: x => str.withThousandsSeparator(x),
        toFixedLocaleString: x => str.toFixedLocaleString(x),
        capitalize: x => str.capitalize(x),
        uppercaseWords: x => str.uppercaseWords(x),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/Filters.js